const STEPS = [
  {
    num: '01',
    title: 'Apply for Access',
    desc: 'Submit your application from this site. We review and approve qualifying merchants.',
  },
  {
    num: '02',
    title: 'Generate Your Solana Wallet',
    desc: 'Create a non-custodial Solana wallet inside the BonesPay dashboard. Only you ever see the seed phrase. We store the public address only.',
  },
  {
    num: '03',
    title: 'Install the Plugin',
    desc: 'Download the BonesPay plugin for your store, paste your API key, and configure your custom hosted checkout from the dashboard.',
  },
  {
    num: '04',
    title: 'Get Paid in USDC',
    desc: 'Customers check out, sign one transaction in their Solana wallet, and the order is automatically marked complete in your store. USDC settles directly to your wallet.',
  },
];

const CHAIN_STEPS = [
  { symbol: '\u25CB', label: 'Customer Submits Order', detail: 'Plugin redirects to hosted checkout' },
  { symbol: '\u25CE', label: 'Hosted Checkout Renders', detail: 'Branded with your colors and logo' },
  { symbol: '\u22A2', label: 'Wallet Signs USDC Transfer', detail: 'One signature, single Solana Pay tx' },
  { symbol: '\u2211', label: 'Solana Confirms On-Chain', detail: 'Transaction parsed and verified' },
  { symbol: '\u03BB', label: 'HMAC Webhook to Store', detail: 'SHA-256 signed callback to plugin' },
  { symbol: '\u220E', label: 'Order Marked Complete', detail: 'Automatic. No manual reconciliation.' },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-bone-white py-12 sm:py-14 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8 text-center">
          <span className="font-mono text-[10px] tracking-widest uppercase text-navy-500">
            Section I &mdash; How It Works
          </span>
          <div className="mt-2 w-full h-px bg-navy-200" />
        </div>

        <h2 className="font-serif text-navy-900 text-3xl md:text-4xl mb-3 text-center">
          Four steps from approved to paid.
        </h2>
        <p className="font-sans text-navy-500 text-base max-w-2xl mb-10 leading-relaxed text-center mx-auto">
          BonesPay handles the crypto rails so you can keep selling on the platform you already use.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
          <div className="flex flex-col justify-center space-y-6">
            {STEPS.map((step) => (
              <div key={step.num} className="flex gap-4 items-start">
                <span className="font-mono text-2xl text-navy-600 font-medium flex-shrink-0 w-8">{step.num}</span>
                <div>
                  <h3 className="font-sans text-sm font-semibold text-navy-900 mb-1">
                    {step.title}
                  </h3>
                  <p className="font-sans text-sm text-navy-500 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-col justify-center">
            <div className="flex items-center gap-2 mb-5">
              <div className="flex-1 h-px bg-navy-200" />
              <span className="font-mono text-[10px] text-navy-400 uppercase tracking-widest">Per-Order Verification</span>
              <div className="flex-1 h-px bg-navy-200" />
            </div>
            <div className="border border-navy-200 rounded-subtle bg-navy-950 overflow-hidden">
              {CHAIN_STEPS.map((step, i) => {
                const isLast = i === CHAIN_STEPS.length - 1;
                return (
                  <div
                    key={step.label}
                    className={`px-5 py-3.5 flex items-start gap-4 ${
                      !isLast ? 'border-b border-navy-800/40' : ''
                    }`}
                  >
                    <span
                      className={`font-mono text-sm flex-shrink-0 select-none mt-px ${
                        isLast ? 'text-emerald-400/80' : 'text-bone-white/30'
                      }`}
                    >
                      {step.symbol}
                    </span>
                    <div>
                      <div
                        className={`font-mono text-xs ${
                          isLast ? 'text-emerald-400/80' : 'text-bone-white/70'
                        }`}
                      >
                        {step.label}
                      </div>
                      <div className="font-mono text-[10px] text-bone-white/25 mt-0.5">
                        {step.detail}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <p className="font-mono text-[10px] text-navy-400 mt-3 text-center">
              Every transaction is verifiable on the Solana blockchain.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
